<div class="main-container lg-view">
  <h3 class="header">Procedure Step Confirmation Request</h3>
  <h5 class="header">
    <h4>
      {{ procedureCopilotDetails.procedureName }}
    </h4>
    <h5>{{ procedureCopilotDetails.assetName }}</h5>
    <h5>{{ procedureCopilotDetails.siteAddress }}</h5>
    <!-- <h4 class="completed-procedure" *ngIf="procedureCopilotDetails.isCompleted">
      Completed
    </h4> -->
  </h5>
  <ng-container
    *ngIf="procedureCopilotDetails?.pendingApprovalJobProcedureForms?.length"
  >
    <div class="panels-title">Steps:</div>
    <div class="procedure-steps">
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="
            let step of procedureCopilotDetails.pendingApprovalJobProcedureForms;
            let i = index;
            trackBy: currentPendingApprovalStepId
          "
          [expanded]="i === expandedStepIndex"
          (opened)="expandedStepIndex = i; getConfirmationHistoryByFormId(step.jobProcedureFormId)"
          [ngClass]="{
            'panel-confirmed': step.isConfirmed,
            'panel-declined': !step.isConfirmed
          }"
        >
          <mat-expansion-panel-header>
            <mat-panel-title> {{ step.stepName }} </mat-panel-title>
            <mat-panel-description>
              <div class="status">
                <ng-container
                  *ngIf="step.isConfirmed && !step.isIssueLogged"
                  class="label"
                >
                  <span>
                    <mat-icon
                      class="svg-icon"
                      [svgIcon]="'check_mark'"
                    ></mat-icon>
                  </span>
                </ng-container>
                <ng-container
                  *ngIf="step.isIssueLogged && !step.isConfirmed"
                  class="label"
                >
                  <span>
                    <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
                  </span>
                </ng-container>
                <ng-container
                  *ngIf="!step.isConfirmed && !step.isIssueLogged"
                  class="label pending"
                >
                  <span>
                    <mat-icon
                      class="svg-icon"
                      [svgIcon]="'hourglass'"
                    ></mat-icon>
                  </span>
                </ng-container>
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-loader *ngIf="isLoading"></app-loader>
          <ng-container *ngIf="!isLoading">
            <div class="panel-content">
              <button mat-raised-button (click)="goToFormDetails(step)">
                Details
              </button>
              <ng-container *ngIf="!!step?.confirmationHistory && step.confirmationHistory.length > 0">
                <div class="confirmation-history">
                  <h4>Confirmation History:</h4>
                  <div
                    class="history-entry"
                    *ngFor="let history of step.confirmationHistory"
                  >
                    <span class="history-status">
                      <b>{{ history.copilotName }} </b>
                      <span *ngIf="history.isConfirmed"> <i>confirmed</i> </span>
                      <span *ngIf="history.isIssueLogged">
                        <i>{{ history?.comment }}</i>
                      </span>
                    </span>
                    <span
                      class="history-date"
                      [ngClass]="{'logged-issue': history?.isIssueLogged}"
                    >
                      on
                      {{ moment(history.lastUpdatedOn).format("MM/DD/YYYY") }}
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="!step.isConfirmed && !step.isIssueLogged">
              <div class="panel-actions">
                <button
                  mat-raised-button
                  class="log-issue-button"
                  (click)="openStepUpdateModal(step)"
                  [disabled]="isLoading"
                >
                  Log Issue
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  (click)="confirmCopilotStep(step)"
                  [disabled]="isLoading"
                >
                  Confirm
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="step.isIssueLogged || step.isConfirmed">
              <div class="panel-actions">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="openStepUpdateModal(step)"
                  [disabled]="isLoading"
                >
                  Update
                </button>
              </div>
            </ng-container>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>

  <ng-container
    *ngIf="
      !procedureCopilotDetails?.pendingApprovalJobProcedureForms ||
      procedureCopilotDetails.pendingApprovalJobProcedureForms.length === 0
    "
  >
    <div class="no-data-container">
      <h4 class="no-data-text">No pending procedure confirmation requests.</h4>
    </div>
  </ng-container>
</div>

<generic-modal #logIssueModal class="update-status-modal" [hideOnBackdropClick]="false">
  <ng-template #modalHeading>
    <!-- title for Log Issue -->
    <ng-container *ngIf="!isStepUpdateValid">
      <h3>Log Issue for Step: {{ selectedStepForIssue?.stepName }}</h3>
    </ng-container>
    <!-- title for Edit Step Confirmation -->
    <ng-container *ngIf="isStepUpdateValid">
      <h3>Update answer for {{ selectedStepForIssue?.stepName }}</h3>
    </ng-container>
  </ng-template>
  <ng-template #modalBody>
    <div class="step-details-container">
      <!-- container for Edit Step Confirmation with issue logged-->
      <ng-container *ngIf="isStepUpdateValid && !isOnLogIssueUpdate">
        <div>
          <span class="existing-comment-label"><b>Current status:</b></span>
          <ng-container *ngIf="selectedStepForIssue?.isIssueLogged">
            <span>Logged issue</span>
            <blockquote class="existing-comment-text">
              <i>{{ selectedStepForIssue?.comment }}</i>
            </blockquote>
          </ng-container>
          <ng-container *ngIf="selectedStepForIssue?.isConfirmed">
            <span>Confirmed</span>
          </ng-container>
        </div>
        <div class="last-updated-on">
          on
          {{ moment(selectedStepForIssue?.lastUpdatedOn).format("MM/DD/YYYY") }}
        </div>
      </ng-container>
      <ng-container *ngIf="!isStepUpdateValid || isOnLogIssueUpdate">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Comment</mat-label>
          <textarea
            matInput
            rows="5"
            [(ngModel)]="logIssueComment"
            placeholder="Describe the issue..."
          ></textarea>
        </mat-form-field>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #modalActions>
    <button
      mat-flat-button
      (click)="closeLogIssueModal()"
      [disabled]="isLoading"
    >
      Cancel
    </button>
    <!-- Submit for Log Issue-->
    <ng-container *ngIf="!isStepUpdateValid">
      <button
        mat-flat-button
        color="primary"
        (click)="submitLogIssue()"
        [disabled]="isLoading || !logIssueComment?.trim()"
      >
        <ng-container *ngIf="!isLoading">Submit Issue</ng-container>
        <ng-container *ngIf="isLoading">
          <mat-spinner diameter="20"></mat-spinner>
        </ng-container>
      </button>
    </ng-container>
    <!-- Submit for Change Step Confirmation answer-->
    <ng-container *ngIf="isStepUpdateValid">
      <button
        mat-flat-button
        color="primary"
        (click)="onLogIssueClick()"
        [disabled]="
          (isLoading || !logIssueComment?.trim()) && isOnLogIssueUpdate
        "
      >
        <ng-container *ngIf="!isLoading">Log issue</ng-container>
        <ng-container *ngIf="isLoading">
          <mat-spinner diameter="20"></mat-spinner>
        </ng-container>
      </button>
      <ng-container
        *ngIf="selectedStepForIssue.isIssueLogged && !isOnLogIssueUpdate"
      >
        <button
          mat-flat-button
          color="primary"
          (click)="confirmCopilotStep(selectedStepForIssue)"
          [disabled]="isLoading"
        >
          <ng-container *ngIf="!isLoading">Confirm</ng-container>
          <ng-container *ngIf="isLoading">
            <mat-spinner diameter="20"></mat-spinner>
          </ng-container>
        </button>
      </ng-container>
    </ng-container>
  </ng-template>
</generic-modal>
